import {
    Comments,
    CommentTargetForSubmission,
    CommentTargetForTask
} from '../../../backbone-unorganized/shared/comments/models';
import { isConnected } from '../../../shared/utils/is';

export const CommentsPageLayoutMixin = {
    comments: null, // Comments

    initialize: function (options) {
        options = options || {};

        if (options.comments) {
            this.comments = options.comments;
        }
    },

    fetch_comments: function (options) {
        options = options || {};
        options.success = options.success || function () {};
        options.error = options.error || function () {};

        var comments_target = null;
        if (options.submission) {
            comments_target = new CommentTargetForSubmission({
                id: options.submission._id.$oid,
                instance: options.submission
            });
        } else if (options.task) {
            comments_target = new CommentTargetForTask({
                id: options.task.id,
                instance: options.task
            });
        }

        this.comments = new Comments(null, {
            target: comments_target
        });

        if (!isConnected()) {
            return options.error({
                message: _t('mobile_empty_list_message_must_be_online')
            });
        }

        this.comments.fetch({
            success: function (response) {
                options.success();
            },
            error: function (response) {
                options.error(response);
            }
        });
    },

    add_comments_tab: async function () {
        var comments_count = '';

        if (this.comments && this.comments.display_length()) {
            comments_count = `(${this.comments.display_length()})`;
        }

        const module = await import('../../../backbone-unorganized/comments/views');

        this.tabs.push({
            id: $f.shared.comments.utils.COMMENTS_TAB_ID,
            tab_class: this.comments.has_unread_comments() ? 'has_unread_comments' : '',
            name: `${_t('mobile_tasks_tab_title_comments')} ${comments_count}`,
            view_class: module.CommentsTab,
            view_options: {
                collection: this.comments,
                task: this.model,
                submission: this.collection
            }
        });

        this._update_nav_item_name();
    },

    _update_nav_item_name: function () {
        var this_ = this;

        this.listenTo(this.comments, 'add change', function () {
            this_.r_tabbed_layout.currentView.update_tab({
                id: $f.shared.comments.utils.COMMENTS_TAB_ID,
                changes: {
                    name: `${_t('mobile_tasks_tab_title_comments')} (${this_.comments.display_length()})`,
                    tab_class: this_.comments.has_unread_comments() ? 'has_unread_comments' : ''
                }
            });
        });
    },

    go_back_comments_tab: function () {
        $f.application.vent.trigger('comments_tab:go_back:post_comment');
    },

    is_comments_tab: function () {
        return this.r_tabbed_layout.currentView.active_tab_id === $f.shared.comments.utils.COMMENTS_TAB_ID;
    }
};
